/**
 * THE CREATE FORMS MUST NOT SET REMINDERS NOBODY ASKED FOR (founder, 2026-09-10: *"I enabled only
 * one reminder. So having more is not something I expect or approve."*).
 *
 * Both portal create forms ship `dayReminders` defaults with morning, day AND evening switched ON,
 * and `dayReminders` is a REQUIRED input (`DayRemindersCreateInputNoThught!`) so the field cannot
 * simply be dropped. For a LEGACY client that is fine and long-standing: the therapist sees the
 * three slots and turns off what they do not want before saving.
 *
 * For an ES client it is not fine, because the three-slot table is no longer the surface they use —
 * the RRULE editor is. The slots are hidden, so the defaults were being written unseen: creating one
 * card produced a `dayReminders` row with all three enabled (09:00 / 14:00 / 21:00) that the
 * therapist never chose and could not reach, ON TOP of the one schedule they actually set. Found in
 * production on card `thoughts/17618`, where the log held exactly one reminder and the legacy row
 * held three.
 *
 * The row still has to exist — the mutation requires it, and a rolled-back subject reads it — so it
 * is written SILENT: the times are kept exactly as they were (they are what a rollback would show,
 * and what the legacy UI would open with) and only `enabled` is cleared. An ES client's real
 * reminders live in the log, set through the RRULE surface, one per deliberate act.
 */
export const withLegacyDaySlotsSilenced = <T>(dayReminders: T): T => {
  if (!dayReminders || typeof dayReminders !== 'object') return dayReminders;
  return Object.fromEntries(
    Object.entries(dayReminders as Record<string, unknown>).map(
      ([slot, value]) => [
        slot,
        // only the three time slots carry `enabled`; `_key`/`thoughtId`/timestamps pass through
        value && typeof value === 'object' && 'enabled' in value
          ? { ...(value as object), enabled: false }
          : value,
      ],
    ),
  ) as T;
};
